// extracted by mini-css-extract-plugin
module.exports = {"Banner":"Banner_Banner__JVHDV","content":"Banner_content__2uHHr","logo":"Banner_logo__xMReH","title":"Banner_title__2OiSw","subtitle":"Banner_subtitle__3xqXu"};